import { createTheme } from '@mui/system';

const MyTheme = createTheme({
  palette: {
    primary: {
      main: '#D9D9D9'
    },
    secondary: {
      main: '#404040'
    }
  }
});

export default MyTheme;
